import Clients from './src/components/Clients';

export default Clients;


// WEBPACK FOOTER //
// ./src/modules/clients/index.js